export default function({ store, redirect }) {
    const { isPremiumUser } = store.getters;

    if (!isPremiumUser) {
        return redirect('/');
    }
}
